import { v4 as uuidv4 } from 'uuid';

export const getTabId = () => {
  let tabId = sessionStorage.getItem('tabId');

  if (!tabId) {
    tabId = uuidv4();
    sessionStorage.setItem('tabId', tabId);
  }

  return tabId;
};
